import ApiServiceV6Core from '@/helpers/api.service.v6core';
const APIV6Core = new ApiServiceV6Core();


export const state = {
    loadPromoList: [],
    loadPromoPageInfo: {
        total: 0
    },
    // Dashboard Summary Data
    eloadSummary: {
        b2bLoadInMTD: 0,
        b2bLoadInPMMTD: 0,
        b2bLoadInPM: 0,
        retailLoadInMTD: 0,
        retailLoadInPMMTD: 0,
        retailLoadInPM: 0,
        b2bLoadOutMTD: 0,
        b2bLoadOutPMMTD: 0,
        b2bLoadOutPM: 0,
        retailLoadOutMTD: 0,
        retailLoadOutPMMTD: 0,
        retailLoadOutPM: 0,
        b2bCM1MTD: 0,
        b2bCM1PMMTD: 0,
        b2bCM1PM: 0,
        retailCM1MTD: 0,
        retailCM1PMMTD: 0,
        retailCM1PM: 0,
        retailCM2MTD: 0,
        retailCM2PMMTD: 0,
        retailCM2PM: 0,
        b2bCM2MTD: 0,
        b2bCM2PMMTD: 0,
        b2bCM2PM: 0
    },
    // Active Users Data
    activeUsers: {
        b2bActiveUsersMTD: 0,
        b2bActiveUsersPMMTD: 0,
        b2bActiveUsersPM: 0,
        retailActiveUsersMTD: 0,
        retailActiveUsersPMMTD: 0,
        retailActiveUsersPM: 0
    },
    // Retail Daily Transactions
    retailDailyTransactions: {},
    retailDailyDates: [],
    // B2B Daily Transactions
    b2bDailyTransactions: {},
    b2bDailyTransactionsPerProvider: [],
    b2bDailyDates: [],
    // Combined Daily Transactions (Provider Load Out)
    dailyTransactionsPerProvider: [],
    dailyDates: []
}

export const mutations = {
    UPDATE_LOADPROMO_LIST(state, list) {
        state.loadPromoList = list;
    },
    UPDATE_LOADPROMO_PAGE_INFO(state, total) {
        state.loadPromoPageInfo.total = total;
    },
    UPDATE_ELOAD_SUMMARY(state, data) {
        state.eloadSummary = { ...state.eloadSummary, ...data };
    },
    UPDATE_ACTIVE_USERS(state, data) {
        state.activeUsers = { ...state.activeUsers, ...data };
    },
    UPDATE_RETAIL_DAILY_TRANSACTIONS(state, data) {
        state.retailDailyTransactions = data.retailDailyTransactions || {};
        state.retailDailyDates = data.dates || [];
    },
    UPDATE_B2B_DAILY_TRANSACTIONS(state, data) {
        state.b2bDailyTransactions = data.b2bDailyTransactions || {};
        state.b2bDailyTransactionsPerProvider = data.b2bDailyTransactionsPerProvider || [];
        state.b2bDailyDates = data.dates || [];
    },
    UPDATE_DAILY_TRANSACTIONS_PER_PROVIDER(state, data) {
        state.dailyTransactionsPerProvider = data.dailyTransactionsPerProvider || [];
        state.dailyDates = data.dates || [];
    }
}

export const actions = {
    // Get E-Load Summary
    getELoadSummary(context) {
        return new Promise((resolve, reject) => {
            APIV6Core.get('/eload/dashboard/eload-summary')
            .then((response) => {
                if (response.data.status === 'ok') {
                    context.commit('UPDATE_ELOAD_SUMMARY', response.data.message);
                }
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },

    // Get Active Users
    getActiveUsers(context) {
        return new Promise((resolve, reject) => {
            APIV6Core.get('/eload/dashboard/active-users')
            .then((response) => {
                if (response.data.status === 'ok') {
                    context.commit('UPDATE_ACTIVE_USERS', response.data.message);
                }
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },

    // Get Retail Daily Transactions
    getRetailDailyTransactions(context, params) {
        return new Promise((resolve, reject) => {
            APIV6Core.post('/eload/dashboard/eload-retail-daily-transactions', params)
            .then((response) => {
                if (response.data.status === 'ok') {
                    context.commit('UPDATE_RETAIL_DAILY_TRANSACTIONS', response.data.message);
                }
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },

    // Get B2B Daily Transactions
    getB2BDailyTransactions(context, params) {
        return new Promise((resolve, reject) => {
            APIV6Core.post('/eload/dashboard/eload-b2b-daily-transactions', params)
            .then((response) => {
                if (response.data.status === 'ok') {
                    context.commit('UPDATE_B2B_DAILY_TRANSACTIONS', response.data.message);
                }
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },

    // Get Daily Transactions Per Provider
    getDailyTransactionsPerProvider(context, params) {
        return new Promise((resolve, reject) => {
            APIV6Core.post('/eload/dashboard/eload-daily-transactions', params)
            .then((response) => {
                if (response.data.status === 'ok') {
                    context.commit('UPDATE_DAILY_TRANSACTIONS_PER_PROVIDER', response.data.message);
                }
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
        });
    }
}

export const getters = {
    // E-Load Summary Getters
    eloadSummary: (state) => state.eloadSummary,
    
    // Active Users Getters
    activeUsers: (state) => state.activeUsers,
    
    // Retail Daily Transactions Getters
    retailDailyTransactions: (state) => state.retailDailyTransactions,
    retailDailyDates: (state) => state.retailDailyDates,
    
    // B2B Daily Transactions Getters
    b2bDailyTransactions: (state) => state.b2bDailyTransactions,
    b2bDailyTransactionsPerProvider: (state) => state.b2bDailyTransactionsPerProvider,
    b2bDailyDates: (state) => state.b2bDailyDates,
    
    // Combined Daily Transactions Getters
    dailyTransactionsPerProvider: (state) => state.dailyTransactionsPerProvider,
    dailyDates: (state) => state.dailyDates
}